import React from "react";
import { UsersContext } from "@/context/UsersContext";

export default function useUsers() {
  return React.useContext(UsersContext);
}
